/**
 * O que faz: Nota discreta de qualidade dos dados (cobertura, atribuição e atualização da fonte).
 * Onde usa: Dashboard, logo abaixo dos cards de "Resultados por canal".
 * Conexões: Recebe cobertura e limitações do contrato por props.
 * Tabelas: Nenhuma direta.
 * Data: 05/09/2026 (virou nota de uma linha, sem card, em 05/10/2026).
 */

import { ShieldCheck } from 'lucide-react';

interface QualidadeDadosDashboardProps {
  origemDados: string;
  qualidadeAtribuicao: string;
  coberturaVinculos: string;
  atualizadoEm: string | null;
}

export function QualidadeDadosDashboard({ origemDados, qualidadeAtribuicao, coberturaVinculos, atualizadoEm }: QualidadeDadosDashboardProps) {
  // Informação de apoio, não de decisão: fica como rodapé dos cards, sem borda nem fundo próprio.
  return (
    <section aria-label="Qualidade dos dados" className="flex items-start gap-2 px-1 text-[11px] leading-relaxed text-muted-foreground">
      <ShieldCheck className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <p>
        Receita registrada · origem dos dados: {origemDados} · {qualidadeAtribuicao} · {coberturaVinculos}{atualizadoEm ? ` · Atualizado às ${atualizadoEm}` : ''}
      </p>
    </section>
  );
}
